import { MimeImage } from "./image";

type Target =
    | "document"
    | "header"
    | "footer"
    | "comment"
    | "endnote"
    | "footnote";

/**
 * Targets in a document
 */
const targetsInDocument: Target[] = [
    "document",
    "header",
    "footer",
    "comment",
    "endnote",
    "footnote",
];

interface OptionsFirstMatch {
    /** Replace only the first match. Default as false */
    firstMatch?: boolean;
}

interface OptionsParseLineBreaks {
    /** Parse line breaks. Default as true */
    parseLineBreaks?: boolean;
}

interface OptionsReplacementType {
    /** Remove type: inline, block  */
    type?: "inline" | "block";
}

interface OptionsRemoveVariableImage
    extends OptionsFirstMatch,
        OptionsReplacementType {}

interface OptionsRemoveVariableText
    extends OptionsFirstMatch,
        OptionsReplacementType {}

interface OptionsReplaceVariableExternalFile extends OptionsFirstMatch {}

interface OptionsReplaceVariableImage extends OptionsFirstMatch {
    /** Height: EMUs value. If -1 do not change the placeholder image height. If not set, use new image height */
    height?: number;
    /** Mime type */
    mime?: MimeImage;
    /** Width: EMUs value. If -1 do not change the placeholder image width. If not set, use new image width */
    width?: number;
}

interface OptionsReplaceVariableList
    extends OptionsFirstMatch,
        OptionsParseLineBreaks {}

interface OptionsReplaceVariableTable
    extends OptionsFirstMatch,
        OptionsParseLineBreaks {}

interface OptionsReplaceVariableText
    extends OptionsFirstMatch,
        OptionsParseLineBreaks {}

interface OptionsReplaceVariableWordFragment
    extends OptionsFirstMatch,
        OptionsReplacementType {}

interface OptionsReplaceVariableWordMl extends OptionsFirstMatch {}

interface OptionsTemplate {
    /** Import default MS Word styles. Default as true */
    importMSWordDefaultStyles?: boolean;
}

const defaultOptionsReplaceVariableExternalFile: OptionsReplaceVariableExternalFile =
    {
        firstMatch: false,
    };

const defaultOptionsTemplate: OptionsTemplate = {
    importMSWordDefaultStyles: true,
};

const defaultOptionsRemoveVariableImage: OptionsRemoveVariableImage = {
    firstMatch: false,
    type: "inline",
};

const defaultOptionsRemoveVariableText: OptionsRemoveVariableText = {
    firstMatch: false,
    type: "inline",
};

const defaultOptionsReplaceVariableImage: OptionsReplaceVariableImage = {
    firstMatch: false,
    mime: "image/png",
};

const defaultOptionsReplaceVariableList: OptionsReplaceVariableList = {
    firstMatch: false,
    parseLineBreaks: true,
};

const defaultOptionsReplaceVariableTable: OptionsReplaceVariableTable = {
    firstMatch: false,
    parseLineBreaks: true,
};

const defaultOptionsReplaceVariableText: OptionsReplaceVariableText = {
    firstMatch: false,
    parseLineBreaks: true,
};

const defaultOptionsReplaceVariableWordFragment: OptionsReplaceVariableWordFragment =
    {
        firstMatch: false,
        type: "block",
    };

const defaultOptionsReplaceVariableWordMl: OptionsReplaceVariableWordMl = {
    firstMatch: false,
};

export {
    defaultOptionsRemoveVariableImage,
    defaultOptionsReplaceVariableExternalFile,
    defaultOptionsRemoveVariableText,
    defaultOptionsReplaceVariableImage,
    defaultOptionsReplaceVariableList,
    defaultOptionsReplaceVariableTable,
    defaultOptionsReplaceVariableText,
    defaultOptionsReplaceVariableWordFragment,
    defaultOptionsReplaceVariableWordMl,
    defaultOptionsTemplate,
    OptionsRemoveVariableImage,
    OptionsRemoveVariableText,
    OptionsReplaceVariableExternalFile,
    OptionsReplaceVariableImage,
    OptionsReplaceVariableList,
    OptionsReplaceVariableTable,
    OptionsReplaceVariableText,
    OptionsReplaceVariableWordFragment,
    OptionsReplaceVariableWordMl,
    OptionsTemplate,
    Target,
    targetsInDocument,
};
